import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {EaAnalysisResultDto} from "../../../../../model/dto/entity/ea-analysis-result.dto";
import {EaColumnDto} from "../../../../../model/dto/entity/ea-column.dto";
import {EaColumnService} from "../../../../../service/api/ea-column.service";

@Component({
    selector: 'ea-project-analysis-tab',
    templateUrl: './ea-project-analysis-tab.component.html',
    standalone: false
})
export class EaProjectAnalysisTabComponent implements OnInit, OnChanges, OnDestroy {

    @Input() objectIdentifier: ObjectIdentifier;

    initialized: boolean;
    analysisResultsWidget: WidgetData;
    selectedAnalysisResult: EaAnalysisResultDto;
    selectedColumn: EaColumnDto;

    constructor(
        protected columnService: EaColumnService
    ) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshWidgets(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }

        const filterCriteria = FilterCriteria.create('sourceFile.project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        this.analysisResultsWidget = WidgetFactory.createWidgetTableEntityBasicQl(
            'ea.project.analysis.results.widget',
            'Analysis Results',
            'ea.EaAnalysisResult',
            [filterCriteria]
        );
    }

    handleAnalysisSelect(event: any): void {
        if (event?.data) {
            this.selectedAnalysisResult = event.data;
            this.selectedColumn = null;
        }
    }

    handleColumnSelect(event: ObjectIdentifierData): void {
        if (event?.objectId) {
            this.columnService.get(event.objectId).subscribe({
                next: (column) => {
                    this.selectedColumn = column as EaColumnDto;
                }
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['objectIdentifier']) {
            this.refreshWidgets();
        }
    }

    ngOnDestroy(): void {
    }
}
